var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#2a374d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    transform: "translate(-611 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_165",
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(611 18)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    transform: "translate(615 22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M8 13H6V4L3.5 3H8v3h2V1H0v14h4.333L6 16v-1h4v-5H8z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M12.293 4.293l-1.414 1.414L12.172 7H7v2h5.172l-1.293 1.293 1.414 1.414L16 8z",
    className: "cls-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.7c23922443802d33229a06a9408a8fe6.svg";
export { ForwardRef as ReactComponent };